import React, { FC, memo } from 'react'
import { CarouselIcon, StyledCarouselNextButton } from './styles'
import { ChevronRightIcon } from '../../common/icons'
import { AnyStyledComponent } from 'styled-components'
import { stopPropagation } from '../../../utils/dom-utils'

const CarouselButtonNext: FC = () => {
    return (
        <div onClick={stopPropagation}>
            <StyledCarouselNextButton $right>
                <CarouselIcon as={ChevronRightIcon as AnyStyledComponent} />
            </StyledCarouselNextButton>
        </div>
    )
}

export default memo(CarouselButtonNext)
